import { PeriodTabType, ProPeriodTabType, TabType } from '@/constants/subscription';
import { atom } from 'jotai';

/** 接口下发的各场景商品入口标识，见 docs/superpowers/specs/2026-03-31-subscription-entries-api-design.md */
export type SubscriptionEntranceEntries = {
  subscription: string;
  subscription_ppt_logo?: string;
  meidou: string;
  cutout: string;
  svip_1: string;
  svip_2: string;
  svip_3: string;
  svip_4: string;
  batch_process: string;
};

/**
 * 全量入口映射缓存（接口成功或兜底填充后写入）
 */
export const subscriptionEntranceEntriesAtom = atom<SubscriptionEntranceEntries | null>(null);

/**
 * 渠道策略ID
 */
export const businessStrategyIdAtom = atom<number | string>('');

/**
 * 是否来自渠道策略用户
 */
export const isFromChannelBusinessAtom = atom<boolean>(false);

/**
 * 会员商品组入口标识
 */
export const subEntranceBizCodeAtom = atom<string>('');

/**
 * 当前tab，商品类型：会员商拍/美豆商品/抠图商品
 * 默认是URL透传控制的default_tab值
 */
export const curTabAtom = atom<TabType>(TabType.SUB);

/**
 * 当前周期类型（新版订阅tab），连续包年/连续包月/单年购买/单月购买
 */
export const curPeriodTabAtom = atom<PeriodTabType>(PeriodTabType.YEARLY);

/**
 * 旧版高级会员 AB 二级 Tab（连续包月/包年）
 * 与新版 curPeriodTabAtom 隔离
 */
export const proPeriodTabAtom = atom<ProPeriodTabType>(ProPeriodTabType.MONTHLY);

/**
 * 接口下发的默认 Tab（与 default_tab 字段对应）
 */
export const apiDefaultTabAtom = atom<TabType | ''>('');

/**
 * 接口下发的默认选中商品 ID（与 selected 字段对应），仅在配置 default_tab 时由后端保证有效
 */
export const apiSelectedProductIdAtom = atom<string>('');

/**
 * 是否购买过美豆（subscribe_entries.has_purchased_meidou）
 * null = 未知/未拉取；false = 未买过（实验人群）；true = 已买过
 */
export const hasPurchasedMeidouAtom = atom<boolean | null>(null);
